import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '../core/services/user.service';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class AT14Services {
  url = `${this.env.URL_API_V1}`;
  baseUrl = `${this.url}/at14`;
  auditoryUrl = `${this.url}/auditory_log`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(    
      private http: HttpClient,
      private userService: UserService,
      private env: EnvService
    ) { }

  // // Método para obtener un cliente por su número de identificación (CI)
  // getClientePorCI(ci: string): Observable<any> {
  //   const url = `${this.baseUrl}/api/clientes/buscar?ci=${ci}`; // Ajusta la ruta según tu backend
  //   return this.http.get<any>(url);
  // }
  uploadFileAT14(file: FormData) {
    return this.http.post(`${this.baseUrl}/uploadAT14`, file);
  }
  
}